import { render, staticRenderFns } from "./TransactionClassifications.vue?vue&type=template&id=12b90bc1"
import script from "./TransactionClassifications.vue?vue&type=script&lang=js"
export * from "./TransactionClassifications.vue?vue&type=script&lang=js"
import style0 from "./TransactionClassifications.vue?vue&type=style&index=0&id=12b90bc1&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports